<template>
  <div class="layout">

    <div class="navbar navbar-expand-lg">
      <router-link class="alert-link navbar-brand" to="/">W&S Docs</router-link>
      <button aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
              data-target="#navbarNav" data-toggle="collapse" type="button">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <router-link class="alert-link nav-link" to="/admin">AdminPanel</router-link>
          <router-link class="alert-link nav-link" to="/admin/methods">Methods</router-link>
          <router-link class="alert-link nav-link" to="/admin/themes">Themes</router-link>
          <router-link class="alert-link nav-link" to="/admin/previews">Previews</router-link>
        </ul>
      </div>
    </div>

    <main class="app-content">
      <div class="content-bg p-3 m-2">
        <router-view></router-view>
      </div>
    </main>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "AdminLayout",
    computed: mapGetters(['AdminAuthStatusGet']),
    created() {
      if (this.AdminAuthStatusGet === false) {
        this.$router.push('/')
      }
    },
  }
</script>

<style scoped>

</style>
